import { MFS_CARD_TYPE } from './constant/constants';
import { containsRelationshipIn } from './constant/internalRelationships';
import { getTags } from './taggingUtils';
/**
 * Converts an MfsCard object to a Card object.
 *
 * @param dataStore MfsDatastore to access items.
 * @param mfsCard The MfsCard item to convert.
 * @param populateTags Optional flag for populating Tags as a list. Default value is true.
 * @returns The Card type object.
 */
export function toCard(dataStore, mfsCard, populateTags = true) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { label, labelId, displayText, id, origin, secondaryLabels, kind, ...entry } = mfsCard;
    const tags = populateTags ? getTags(mfsCard.id, dataStore) : [];
    const result = {
        ...entry,
        tags: tags,
        uniqueId: labelId,
    };
    return result;
}
/**
 * Get all parent cardIds up to the root card, without getting trapped in a graph cycle.
 * @param dataStore Mfs Datastore
 * @param mfsIds The MfsItem.itemIds to start the search from.
 */
export function* getDistinctParentCardIds(dataStore, mfsIds) {
    // Collection used to hold all MFSIds. Use iterator to visit each value, but keep the value in the collection to make sure we don't visit the same value twice.
    const mfsIdsToCheck = new Set();
    mfsIds.forEach((i) => mfsIdsToCheck.add(i));
    const mfsIdsToCheckIterator = mfsIdsToCheck.values();
    for (const curMfsIdToCheck of mfsIdsToCheckIterator) {
        for (const parent of dataStore.getRelatedItems(curMfsIdToCheck, containsRelationshipIn)) {
            if (parent.label === MFS_CARD_TYPE && parent.labelId && !mfsIdsToCheck.has(parent.id)) {
                mfsIdsToCheck.add(parent.id);
                yield parent.labelId;
            }
        }
    }
}
//# sourceMappingURL=cardUtils.js.map